import axios from 'axios';
import API_HOST from '../api';

const clientApi = function() {
  const api = {};

  api.getLicenseList = function(clientId) {
    const url = `${API_HOST}/api/client/${clientId}/license-list`;
    return axios.get(url);
  };

  api.getClientMaxProductTimeout = function(clientId) {
    const url = `${API_HOST}/api/client/${clientId}/max-product-timeout`;
    return axios.get(url);
  };

  return api;
};

export default clientApi();
